<template>
  <transition name="modal">
    <div class="modal-mask">
      <div ref="wrapper" class="modal-wrapper" @click="close">
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body" class="modal-body-details">default body</slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalComponent',

  methods: {
    close (e) {
      document.body.style.overflow = 'auto'
      if (e.target !== this.$refs.wrapper) return
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss' scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.modal-wrapper {
  align-items: center;
  display: flex;
  min-height: 100%;
  justify-content: center;
  z-index: 50;
  padding: 32px 16px;
  padding-top: max(32px, env(safe-area-inset-top));
  padding-bottom: max(32px, env(safe-area-inset-bottom));
  box-sizing: border-box;

  @include media(phone) {
    padding: 12px;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-bottom: max(48px, calc(env(safe-area-inset-bottom) + 16px));
    align-items: flex-start;
  }
}

.modal-container {
  background-color: #ffffff;
  display: block;
  height: auto;
  margin: 0px auto;
  transition: all 0.3s ease;
  max-width: 100%;

  border: 5px solid #B98A30;
  border-radius: 2px;

  @include media(phone) {
    width: 100%;
    border-width: 3px;
  }
}

.modal-body {
  max-width: 100%;
}

.modal-body {
  border-radius: 2px;
  height: auto;
  margin: 0px auto;
  text-align: center;
  width: 100%;
}

// Transition

.modal-enter-active, .modal-leave-active {
  transition: opacity .5s;

  & .modal-container {
    transition:
      transform .5s ease;

    transform: scale(1);
    will-change: transform, opacity;
  }
}
.modal-enter, .modal-leave-to {
  transition: opacity .2s;
  opacity: 0;

  & .modal-container {
    transform: scale(0.95);
  }
}
</style>
